export default __webpack_public_path__ + "static/investment-grid-background-mountains-34079b82683229da160ee818233b0923.jpg";